import React from 'react'
import WarehouseOccupancy from '../component/WarehouseOccupancy';

function Statistics() {

  return (
    <div>
      <WarehouseOccupancy />
    </div>
  )
}

export default Statistics